import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    this.message = document.createElement('div');
    this.message.className = 'field-validation';
    this.message.popover = 'manual';
    this.message.setAttribute('role', 'alert');
    this.element.append(this.message);
  }

  disconnect() {
    this.hide();
    this.message.remove();
  }

  show(event) {
    event.preventDefault();

    if (this.showing) {
      return;
    }

    this.showing = true;
    queueMicrotask(() => {
      this.showing = false;
    });

    const field = event.target;

    this.hide();
    field.focus();
    this.message.textContent = field.validationMessage;
    this.#describe(field);
    this.#anchorTo(field);
    this.message.showPopover();
  }

  hide() {
    if (this.message.matches(':popover-open')) {
      this.message.hidePopover();
    }

    this.#undescribe();

    if (this.driftHandler) {
      window.removeEventListener('resize', this.driftHandler);
      window.removeEventListener('scroll', this.driftHandler, true);
      this.driftHandler = null;
    }
  }

  #describe(field) {
    this.field = field;
    field.setAttribute('aria-invalid', 'true');

    const key = field.id || field.name;

    if (!key) {
      return;
    }

    this.message.id = `${key}-validation`;
    this.describedBy = field.getAttribute('aria-describedby');
    this.described = true;
    field.setAttribute(
      'aria-describedby',
      [this.describedBy, this.message.id].filter(Boolean).join(' ')
    );
  }

  #undescribe() {
    if (!this.field) {
      return;
    }

    this.field.removeAttribute('aria-invalid');

    if (this.described) {
      if (this.describedBy) {
        this.field.setAttribute('aria-describedby', this.describedBy);
      } else {
        this.field.removeAttribute('aria-describedby');
      }
    }

    this.field = null;
    this.describedBy = null;
    this.described = false;
  }

  #anchorTo(field) {
    const { left, bottom } = field.getBoundingClientRect();
    this.message.style.left = `${left}px`;
    this.message.style.top = `${bottom}px`;

    this.driftHandler = () => this.hide();
    window.addEventListener('resize', this.driftHandler);
    window.addEventListener('scroll', this.driftHandler, true);
  }
}
